import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { Section } from '@connected/ui/features/layouts';
import { Container } from '@connected/ui/layouts/container';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { CompletionForm } from '@/components/features/completion';
import { FooterNavigation } from '@/components/navigation/footer-navigation';

export const Route = createFileRoute(
    '/(auth)/projects/$projectVersionId/re-inspections/completion/',
)({
    component: Page,
    loader: ({ context, params }) => {
        context.queryClient.ensureQueryData(elektraAppQueryOptions.project.inspection.conclusion.conclusionEditOptions({
            electricalProjectVersionId: params.projectVersionId,
        }));
        context.queryClient.ensureQueryData(elektraAppQueryOptions.project.schedule.projectUsersListOptions({
            electricalProjectVersionId: params.projectVersionId,
            userKind: 'CertifiedInspector',
        }));
    },
});

function Page() {
    const { t } = useTranslation('re-inspections');
    const params = Route.useParams();

    return (
        <>
            <Container>
                <Container.Header>
                    <Container.Title>{t('completion.title')}</Container.Title>
                </Container.Header>
                <Container.Content>
                    <CompletionForm projectVersionId={params.projectVersionId} />
                </Container.Content>
                <Section.Footer>
                    <FooterNavigation />
                </Section.Footer>
            </Container>
        </>
    );
}
